import { useEffect, useRef, useState } from 'react';

export const useToast = (defaultDuration = 2000) => {
  const [isShow, setIsShow] = useState(false);
  const [message, setMessage] = useState('');
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const closeToast = () => {
    setIsShow(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const openToast = (msg: string, duration = defaultDuration) => {
    closeToast();
    setMessage(msg);
    setIsShow(true);
    timerRef.current = setTimeout(() => {
      setIsShow(false);
      timerRef.current = null;
    }, duration);
  };

  useEffect(() => () => closeToast(), []);

  return { isShow, message, openToast, closeToast };
};